import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Dialog as MUIDialog } from "@material-ui/core";
import withSizes from "react-sizes";
import UploadFrontAndBack from "./UploadFrontAndBack";
import MultipleFileUploadDialog from "./MultipleFileUploadDialog";
import { dialogSelectors } from "@store/ducks";

const Dialog = ({ type, open, onClose, isMobile }) => {
  const getChild = (type) => {
    let child = "";
    switch (type) {
      case "two-file-upload": {
        child = <UploadFrontAndBack />;
        break;
      }
      case "multi-file-upload": {
        child = <MultipleFileUploadDialog />;
        break;
      }
      default: {
        child = null;
      }
    }
    return child;
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <>
      {getChild(type) ? (
        <MUIDialog
          open={open}
          onClose={type == "two-file-upload" || type == "multi-file-upload" ? () => {} : handleClose}
          maxWidth={"md"}
          PaperProps={
            type === "multi-file-upload" || type === "two-file-upload"
              ? {
                  style: {
                    backgroundColor: "transparent",
                    boxShadow: "none",
                  },
                }
              : {}
          }
        >
          {getChild(type)}
        </MUIDialog>
      ) : (
        <></>
      )}
    </>
  );
};

Dialog.propTypes = {
  type: PropTypes.string,
  open: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

Dialog.defaultProps = {
  type: "",
  open: false,
  isMobile: false,
  dialogOnClose: () => {},
};

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 768,
});
const ResponsiveDialog = withSizes(mapSizesToProps)(Dialog);

const mapStateToProps = (state) => {
  return {
    open: dialogSelectors.open(state),
    type: dialogSelectors.type(state),
  };
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ResponsiveDialog);
